import { container } from "assets/js/material-kit-react.js";

const tabsStyle = {
  section: {
    background: "#EEEEEE",
    padding: "70px 0",
  },
  container,
  textCenter: {
    textAlign: "center",
  },
};

export default tabsStyle;
